import React from 'react';
import { connect } from 'react-redux';
import { AuBankAccountElement } from '@stripe/react-stripe-js';
import get from 'lodash.get';
import { cardElementChange } from '../reducer';

class BankAccountView extends React.Component {
    onCardChange = card => {
        this.props.onCardChange(card);
    }

    render() {
        return (
            <div className="required field">
                {
                    this.props.showHeader &&
                    <label className="card-header">Bank account details</label>
                }
                <AuBankAccountElement
                    id="au-bank-account-element"
                    onChange={this.onCardChange}
                    options={{
                        style: {
                            base: { fontFamily: this.props.fontName, fontSize: "16px" },
                        },
                        disabled: false,
                        hideIcon: false,
                        iconStyle: "default",
                    }}
                />
                {
                    this.props.errorMessage &&
                    <p className="c-error">{this.props.errorMessage}</p>
                }
            </div>
        );
    }
}

const mapState = state => {
    const fontName = get(state, "customization.stripeCardElementFontName") ? get(state, "customization.stripeCardElementFontName") : "Lato";
    return {
        errorMessage: state.donation.cardErrorMessage,
        fontName
    };
};

const mapDispatch = dispatch => {
    return {
        onCardChange: (card) => {
            dispatch(cardElementChange(card));
        },
    };
};

const BankAccount = connect(mapState, mapDispatch)(BankAccountView);
export default BankAccount;
